import React from 'react';

/**
 * Shared hero for public marketing pages — matches HomePage visual language.
 */
export default function MarketingHero({ badge, title, titleAccent, description, children }) {
  return (
    <header className="relative overflow-hidden bg-gradient-to-br from-[#0c1f18] via-emerald-950 to-[#042f2e] pt-24">
      <div className="pointer-events-none absolute inset-0 bg-pattern-dots opacity-[0.07]" />
      <div className="pointer-events-none absolute -right-20 top-16 h-80 w-80 rounded-full bg-emerald-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-teal-400/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 md:py-20 lg:px-8">
        <div className="mx-auto max-w-4xl text-center">
          {badge ? (
            <p className="mb-5 inline-flex items-center justify-center rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm font-medium text-emerald-100/95 backdrop-blur-sm">
              {badge}
            </p>
          ) : null}

          <h1 className="font-serif text-4xl font-bold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
            {title}
            {titleAccent ? (
              <span className="mt-2 block bg-gradient-to-r from-emerald-200 via-teal-200 to-cyan-200 bg-clip-text text-transparent">
                {titleAccent}
              </span>
            ) : null}
          </h1>

          {description ? (
            <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-stone-200/90 sm:text-xl">{description}</p>
          ) : null}

          {children}
        </div>
      </div>
    </header>
  );
}
